import { FC } from "react";

import { ACCESS_ID_QUERY_PARAM } from "components/constants";
import { PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppSelector } from "store/index";
import { selectSortedUserFullSubmissionsByPageId } from "store/selectors";
import { useQueryParam } from "utils/routing";

interface OlderSubmissionAssessedBannerProps {
  page: PageType;
}

export const OlderSubmissionAssessedBanner: FC<OlderSubmissionAssessedBannerProps> = ({ page }) => {
  const selectedAccessId = useQueryParam(ACCESS_ID_QUERY_PARAM);

  const userSubmissions = useAppSelector((s) =>
    selectSortedUserFullSubmissionsByPageId(s, page.id, selectedAccessId || undefined),
  );

  if (!selectedAccessId || userSubmissions.length === 0) {
    return null;
  }

  const officialSubmissionIndex = userSubmissions.findIndex((s) => s.official_at);

  // With ascending sort (oldest first), check if there are newer submissions after the official one
  // to note if the older submission has already been assessed.
  // TODO: This shows the banner even if the instructor is viewing the older submission - which
  // should probably instead show a different banner saying there are newer unassessed submissions.
  if (officialSubmissionIndex >= 0 && officialSubmissionIndex < userSubmissions.length - 1) {
    return (
      <Banner className="page-block-width" kind="warning">
        {t("warning.older_submission_has_already_been_assessed", {
          assessmentIndex: officialSubmissionIndex + 1,
        })}
      </Banner>
    );
  }

  return null;
};
